import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import Box from "@mui/material/Box";
import React, { useEffect, useRef, useState } from "react";
import splashBG from "../../images/splashBG.png";
import { AiOutlineArrowLeft, AiOutlineRight } from "react-icons/ai";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import list_item_bg from "../../images/list_item_bg.png";
import clip_normal from "../../images/clip_normal.png";
// import sp
Modal.setAppElement(document.getElementById("root"));
const SelectRecipies = ({}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dataItems, preSelectedRecipes, from } = location.state || {};

  // console.log("dataItems 6666", from);
  // preSelectedRecipies
  const [selectedSearch, setselectedSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selected, setSelected] = useState(preSelectedRecipes || []);
  // console.log('location', location)
  // const { preSelected, onSelect, dataItems, } = location.state;

  // const data = location.state;
  // console.log('dataItems');
  // const [dataItems, setdociID] = useState(
  //   location.state != null ? location.state.dataItems : ""
  // );

  // console.log(".dataItems", dataItems);
  // // console.log("dataItems:", dataItems);
  // console.log("preSelected:", preSelectedRecipes);
  // console.log("onSelect:", onSelect);

  const filteredList = dataItems.filter((item) =>
    item.craftname.toLowerCase().includes(searchValue.toLowerCase())
  );

  function searchingItem(e) {
    let text = e.target.value;
    setSearchValue(text);
    // if (text.length == 0) {
    //   setfilteredlibraryArray(dataItems);
    //   return;
    // }
  }
  const toggleSelection = (item) => {
    setSelected((prev) => {
      const exists = prev.some((selectedItem) => selectedItem.key === item.key);
      if (exists) {
        return prev.filter((selectedItem) => selectedItem.key !== item.key);
      } else {
        return [...prev, item];
      }
    });
  };

  // console.log("location.pathname", location.pathname);
  const handleOnBack = (value) => {
    //

    if (value == "backWithValue" && selected.length > 0) {
      navigate(from, {
        state: {
          ...location.state,
          onSelect: selected,
        },
      });
    } else if (value == "onlyBack") {
      navigate(from, {
        replace: true,
        state: { ...location.state, onSelect: null },
      });
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: 15,
        backgroundImage: `url(${splashBG})`,
        backgroundRepeat: "repeat",
        backgroundColor: (t) =>
          t.palette.mode === "light" ? t.palette.grey[50] : t.palette.grey[900],
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box sx={{ width: "95%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button onClick={() => handleOnBack("onlyBack")}>
            <AiOutlineArrowLeft
              style={{
                width: 20,
                height: 20,

                color: "#fff",
              }}
            />
          </Button>
          {/* <p style={{ fontSize: 30, color: "#D28816" }}>MY CRAFT</p>' */}

          <TextField
            InputLabelProps={{
              style: {
                fontWeight: "bold",
                color: "#f7a828",
              },
            }}
            inputProps={{
              style: {
                height: "5px",
              },
            }}
            placeholder={"Search by name..."}
            style={{ backgroundColor: "#fff", borderRadius: 10 }}
            fullWidth
            required
            id="search"
            name="search"
            hiddenLabel={true}
            value={searchValue}
            onChange={(e) => searchingItem(e)}
          />

          <Button
            onClick={() => handleOnBack("backWithValue")}
            style={{
              paddingLeft: 20,
              paddingRight: 20,
              fontSize: 18,
              color: "lightgreen",
            }}
          >
            <p style={{}}>Done</p>
            <p style={{ marginLeft: 5 }}> ✓</p>
            {/* <input type="checkbox" checked={true} onBeforeInputCapture={false} /> */}
          </Button>
        </div>
        <div style={{ height: 20 }} />
        <Grid
          container
          //height={200}
          spacing={{ xs: 3, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {filteredList.map((prop, index) => {
            return (
              <Grid item xs={6}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    borderRadius: 5,
                    height: "60px",
                    cursor: "pointer",
                    //width: "100%",
                    //backgroundColor: "#fff",
                    // marginBottom: 10,
                    // marginLeft: (index % 2) ? 10 : 0
                    backgroundImage: `url(${list_item_bg})`,
                    backgroundRepeat: "repeat",

                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                  onClick={() => {
                    toggleSelection(prop);
                    // console.log("selected 66678", prop);
                  }}
                  //    setselectedIndex(index);

                  //    selectedItem = prop;
                  //    // console.log('selectedItem555' , selectedItem)
                  //    setSelectedRecipes([selectedItem]);
                  //    if (fromNetwork) {
                  //      setloading(true);
                  //      addRecipeToNetwork();
                  //    } else {
                  //      console.log("clicke");
                  //      openModal();
                  //    }
                  //  }}
                >
                  <img
                    style={{ widows: 50, height: 50, marginLeft: 10 }}
                    src={clip_normal}
                    alt="tutorial"
                  />
                  <div
                    style={{
                      width: "5%",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <p
                      // className="App"
                      style={{
                        fontSize: 12,
                        //height: 40,
                        color: "#000",
                        textAlign: "start",
                        //marginLeft: '35%',
                        //marginTop: '32%'
                      }}
                    >
                      #{index + 1}
                      {/* <br/>{craf.craftname} */}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "80%",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <p
                      style={{
                        fontSize: 15,
                        color: "#000",
                        textAlign: "start",
                        marginLeft: "3%",
                        //marginTop: '4%'
                      }}
                    >
                      {prop.craftname}
                    </p>
                  </div>

                  <Box
                    // onClick={() =>  console.log('dfkjhdsj')}
                    style={{
                      border: 1,
                      height: 15,
                      width: 15,
                      position: "relative",
                      top: 20,
                      border: "1px solid #000",
                      borderColor: "#000",
                      padding: 2,
                      right: 10,
                    }}
                  >
                    {selected.some((i) => i.key === prop.key) && <span>✓</span>}
                  </Box>
                  {/* </Button> */}
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};
export default SelectRecipies;
